import React, { useId, useState } from "react";
import { colors, shadows, spacing, typography } from "./tokens";

export default function CollapsibleSection({ title, titleMeta = null, children, defaultOpen = false }) {
  const [open, setOpen] = useState(Boolean(defaultOpen));
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const contentId = useId();

  return (
    <section
      style={{
        ...sectionStyle,
        borderColor: open || isHovered ? colors.borderStrong : colors.border,
        boxShadow: isFocused ? `0 0 0 3px ${colors.focusRing}` : sectionStyle.boxShadow,
      }}
    >
      <button
        type="button"
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
        aria-controls={contentId}
        style={{
          ...headerButtonStyle,
          color: colors.textPrimary,
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      >
        <span style={headerContentStyle}>
          <span style={titleStyle}>{title}</span>
          {titleMeta ? <span style={titleMetaStyle}>{titleMeta}</span> : null}
        </span>
        <span style={toggleStyle}>{open ? "Hide" : "Show"}</span>
      </button>
      {open && (
        <div id={contentId} style={contentStyle}>
          {children}
        </div>
      )}
    </section>
  );
}

const sectionStyle = {
  padding: spacing.md + spacing.sm,
  borderRadius: 12,
  background: colors.surface,
  border: `1px solid ${colors.border}`,
  boxShadow: shadows.sm,
  transition: "border-color 120ms ease, box-shadow 120ms ease",
};

const headerButtonStyle = {
  width: "100%",
  border: "none",
  background: "transparent",
  cursor: "pointer",
  padding: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: spacing.md,
};

const headerContentStyle = {
  display: "flex",
  alignItems: "center",
  gap: spacing.md,
  flexWrap: "wrap",
  minWidth: 0,
};

const titleStyle = {
  fontSize: typography.size.lg,
  color: colors.textPrimary,
  fontWeight: typography.weight.medium,
};

const titleMetaStyle = {
  display: "flex",
  alignItems: "center",
  gap: spacing.sm,
  flexWrap: "wrap",
};

const toggleStyle = {
  fontSize: typography.size.xs,
  color: colors.textMuted,
  fontWeight: typography.weight.medium,
};

const contentStyle = {
  marginTop: spacing.xl,
  display: "grid",
  gap: spacing.xl,
};
